import { HierarchyContextProps } from "../interface";

/**
 * Clears save flags after a failed hierarchy save.
 *
 * @param state - The current hierarchy context state.
 * @returns The updated hierarchy context state.
 */
export const hcr_saveHierarchyFailed = (state: HierarchyContextProps): HierarchyContextProps => ({
  ...state,
  doSave: false,
  doTocSave: false,
  saveTocDescription: undefined,
});
